import proje1 from './static/proje1.png'
import proje2 from './static/proje2.png'
import proje3 from './static/proje3.jpg'
import proje4 from './static/proje4.png'
import proje5 from './static/proje5.png'
import proje6 from './static/proje6.png'
import proje7 from './static/proje7.jpeg'
import proje8 from './static/proje8.png'
import proje9 from './static/proje9.jpg'
import proje10 from './static/proje10.jpg'
import proje11 from './static/proje11.jpg'
import HtmlIcon from '@mui/icons-material/Html';
import CssIcon from '@mui/icons-material/Css';
import JavascriptIcon from '@mui/icons-material/Javascript';
import CodeIcon from '@mui/icons-material/Code';


export const pageLinks = [
    {id:1, href:'#home', text:'home'},
    {id:2, href:'#about', text:'about'},
    {id:3, href:'#experience', text:'experience'},
    {id:4, href:'#education', text:'education'},
    {id:4, href:'#projects', text:'projects'},
    {id:4, href:'#skills', text:'skills'},
    {id:4, href:'#contact', text:'contact'},
];

export const project = [
    {id:1, 
    image:proje1,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Portfolyo Web Site', 
    info:'A website developed using HTML5, CSS3, Bootstrap 5, and Javascript, with a responsive design.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    },
    {id:2, 
    image:proje2,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Cora Web Site', 
    info:'A website developed using HTML5, CSS3, Bootstrap 5, and Javascript, with a responsive design.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    },
    {id:3, 
    image:proje3,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Our Tours', 
    info:'A travel promotion website developed using React.js with a responsive design. Basic web site project.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    },
    {id:4, 
    image:proje4,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Pinterest', 
    info:'A CLONE Website developed using HTML5, CSS3, Bootstrap 5, JavaScript, Python, and Django.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    icon4:<CodeIcon />,
    },
    {id:5, 
    image:proje5,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Netflix', 
    info:'A CLONE Website developed using HTML5, CSS3, Bootstrap 5, JavaScript, Python, and Django.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    icon4:<CodeIcon />,
    },
    {id:6, 
    image:proje6,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Exxen', 
    info:'A CLONE Website developed using HTML5, CSS3, Bootstrap 5, JavaScript, Python, and Django.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    icon4:<CodeIcon />,
    },
    {id:7, 
    image:proje7,
    href: 'https://myportfolyoweb.netlify.app',
    title:'AirBnb Web Site', 
    info:'A CLONE Website developed using HTML5, CSS3, Bootstrap 5, JavaScript, Python, and Django.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    icon4:<CodeIcon />,
    },
    {id:8, 
    image:proje8,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Backroads App', 
    info:'A sleek, elegant, and responsive website developed with React.js. "React.js libraries were utilized."',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    },
    {id:9, 
    image:proje9,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Dr. Web Site', 
    info:'A website developed using HTML5, CSS3, Bootstrap 5, and Javascript, with a responsive design.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon3:<JavascriptIcon />,
    },
    {id:10, 
    image:proje11,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Art Gallery Web Site', 
    info:'A website developed using HTML5, CSS3, Bootstrap 5 with a responsive design.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon4:<CodeIcon />,
    },   
    {id:10, 
    image:proje10,
    href: 'https://react-myblog-web.netlify.app/',
    title:'Social Web Site', 
    info:'A website developed using HTML5, CSS3, Bootstrap 5 with a responsive design.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon4:<CodeIcon />,
    },   
    {id:10, 
    image:proje10,
    href: 'https://myportfolyoweb.netlify.app',
    title:'Hospital Web Site', 
    info:'A website developed using HTML5, CSS3, Bootstrap 5 with a responsive design.',
    icon1:<HtmlIcon />,
    icon2:<CssIcon />,
    icon4:<CodeIcon />,
    },   
];